import { FC } from 'react';

import { SwimlaneItem } from '../../forces/assetDetails/assetDetails.types';
import { CheckFilledCircle } from '../../icons';
import { DurationBar } from '../durationBar/DurationBar';

import { BroadcastTimeOverlay } from './BroadcastTimeOverlay';
import { ExpiredOverlay } from './ExpiredOverlay';
import { ImageOverlayWrapper } from './ImageOverlayWrapper';
import { LiveBroadcastOverlay } from './LiveBroadcastOverlay';
import { PadlockOverlay } from './PadlockOverlay';

import styles from '../coverPage/episodes/Episode.module.css';

interface OverlayProps {
  showUpcomingBroadcastTime?: boolean;
  duration?: number;
  vodProgress?: number;
  programState: SwimlaneItem['programState'];
}
export const EpisodeListItemImageOverlay: FC<OverlayProps> = ({ vodProgress, programState }) => {
  if (programState.type === 'NoAccess') {
    return <PadlockOverlay iconSize="normal" label={programState.label} />;
  }

  if (vodProgress) {
    return (
      <ImageOverlayWrapper backdropStyle="gradient">
        {vodProgress >= 0.95 ? (
          <CheckFilledCircle className={styles.episodeCompleted} />
        ) : (
          <DurationBar className={styles.episodeProgress} percent={vodProgress * 100} />
        )}
      </ImageOverlayWrapper>
    );
  }

  if (programState.type === 'Live') {
    return (
      <LiveBroadcastOverlay
        state={programState.type}
        progress={programState.progressPercentage}
        label={programState.label}
      />
    );
  }
  if (programState.type === 'Planned') {
    return <BroadcastTimeOverlay label={programState.label} />;
  }

  if (programState.type === 'Expired') {
    return <ExpiredOverlay iconSize="large" label={programState.label} />;
  }
  return null;
};
